module.exports = __webpack_public_path__ + "static/img/phone.64c80c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = JhOT
// module chunks = 34